import { Itinerario } from './itinerario';

export class ElencoItinerari {
    elenco:     Array<Itinerario>;
    page:       number;
    size:       number;
    maximumPages:   number;
    pageSize:   number;
    totalElements:   number;
}
